import type { DocumentInReview } from './document-reviews.model';

export interface DocumentReviewRow {
  attachmentId: string;
  name: string;
  title: string;
  uploadedAt: string;
  isResubmission: boolean;
  link: string[] | null;
}

export const toDocumentReviewRow = (
  documentInReview: DocumentInReview,
  canViewProfile: (employeeId: string) => boolean,
): DocumentReviewRow => ({
  attachmentId: documentInReview.attachment_id,
  name: documentInReview.employee_name,
  title: documentInReview.title,
  uploadedAt: documentInReview.uploaded_at,
  isResubmission: documentInReview.is_resubmission,
  link: canViewProfile(documentInReview.employee_id) ? ['/employees', documentInReview.employee_id, 'files'] : null,
});
